module.exports = __webpack_public_path__ + "img/s3-title.7e863a0c.png";